import { GridGroup } from '../types';

export const recalculatePageIndexes = (groups: GridGroup[]): GridGroup[] => {
  let currentIndex = 0;

  return groups.map((group) => {
    const updatedItems = group.items.map((item) => ({
      ...item,
      pageIndex: currentIndex++
    }));

    return {
      ...group,
      items: updatedItems
    };
  });
};
